import { render } from "./LicenseAgreement.vue?vue&type=template&id=352fe84b&ts=true"
import script from "./LicenseAgreement.vue?vue&type=script&lang=ts"
export * from "./LicenseAgreement.vue?vue&type=script&lang=ts"

import "./LicenseAgreement.vue?vue&type=style&index=0&id=352fe84b&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__